<template>
  <div class="windows-tips" v-if="isWindowTips" :style="{opacity:isWindowTips?1:0}">
    <div class="tips-content">
      <p>Please Open In App</p>
      <p>
        <button @click="close">Ok</button>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isWindowTips: {
      default() {
        return true
      },
      required: false
    }
  },
  methods: {
    close() {
      this.$emit('closeWindowsTip')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../scss/rem.scss';
.windows-tips {
  position: absolute;
  z-index: 10000000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s linear;
  -webkit-transition: opacity 0.3s linear;
}
.tips-content {
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  height: 200px;
  background: #fff;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  font-size: 18px;
  color: #888;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  > p {
    flex: 1;
    line-height: 100px;
    width: 100%;
    text-align: center;
    > button {
      width: 80px;
      height: 40px;
      color: #fff;
      background: #008adb;
      font-size: 18px;
      border: 0;
      outline: none;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>